import type { TranslationDict } from '../en';

const hr: TranslationDict = {
  'header.buy': 'Kupi',
  'header.sell': 'Prodaj',
  'spend.label': 'Vi trošite',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Vi dobivate',
  'payment.label': 'Način plaćanja',
  'payment.select': 'Odaberi',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Nema dostupnih načina plaćanja za ovaj par',
  'wallet.label': 'Adresa novčanika za primanje',
  'wallet.placeholderBuy': 'Unesite adresu za primanje',
  'wallet.placeholderSell': 'Unesite adresu za slanje',
  'wallet.validating': 'Provjera adrese...',
  'wallet.invalid': 'Unesite valjanu adresu novčanika',
  'wallet.invalidServer': 'Nevaljana adresa novčanika',
  'cta.buy': 'Kupi {crypto}',
  'cta.sell': 'Prodaj {crypto}',
  'cta.gettingPrice': 'Tražimo najbolju cijenu...',
  'cta.processing': 'Obrada...',
  'footer.poweredBy': 'Pokreće ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Pregled tečaja',
  'rate.close': 'Zatvori',
  'rate.updatesIn': 'Tečaj se osvježava za 00:{seconds}',
  'rate.noQuote': 'Nema dostupne ponude',
  'rate.exchangeRate': 'Tečaj razmjene',
  'rate.processingFee': 'Naknada za obradu',
  'rate.networkFee': 'Mrežna naknada',
  'rate.provider': 'Pružatelj usluge',
  'toast.orderCreated': 'Narudžba je kreirana',
  'toast.redirecting': 'Preusmjeravanje na plaćanje...',
  'toast.orderFailed': 'Narudžba nije uspjela',
  'toast.couldNotCreate': 'Narudžba nije mogla biti kreirana',
  'toast.quoteError': 'Greška ponude',
  'toast.noProviders': 'Nema pružatelja usluge',
  'toast.somethingWrong': 'Nešto je pošlo po krivu',
  'error.amountZero': 'Iznos mora biti veći od 0',
  'error.minAmountFiat': 'Minimalni iznos je {min} {currency}',
  'error.minAmountCrypto': 'Minimalni iznos je {min} {currency}',
  'error.noProviders': 'Nema dostupnih pružatelja usluge za ovu kombinaciju',
  'error.currencyUnavailableBuy': 'Ova valuta nije dostupna za kupnju',
  'error.currencyUnavailableSell': 'Ova valuta nije dostupna za prodaju',
  'parity.info': 'Bit će vam naplaćeno za {receiveAmount} {crypto}, ostatak do {spendAmount} {fiat} bit će odobren na vaš {partner} račun',
  'redirect.secureBadge': 'Sigurno plaćanje',
  'redirect.title': 'Nastavi s plaćanjem',
  'redirect.description': 'Bit ćete preusmjereni na {gateway} kako biste dovršili plaćanje.',
  'redirect.countdown': 'Preusmjeravanje za {seconds}...',
  'redirect.openTab': 'Otvori ACH u novoj kartici',
  'redirect.cancel': 'Odustani',
  'checkout.noOrder': 'Narudžba nije pronađena',
  'checkout.goBack': 'Natrag',
  'checkout.expired': 'Odjava je istekla',
  'checkout.expiredDesc': 'Sesija je istekla. Molimo pokušajte ponovo.',
  'checkout.startOver': 'Počni ispočetka',
  'checkout.cancel': 'Odustani',
  'checkout.loading': 'Učitavanje odjave...',
  'checkout.iframeTitle': 'Odjava kod pružatelja',
  'checkout.widgetTitle': 'Blagajna plaćanja',
  'checkout.unknownMethod': 'Nepoznati način odjave',
  'processing.default': 'Obrada vaše narudžbe...',
  'processing.pending': 'Čekanje na potvrdu plaćanja...',
  'processing.active': 'Obrada vaše transakcije...',
  'processing.generic': 'Obrada...',
  'processing.checkingStatus': 'Provjera statusa...',
  'processing.orderId': 'ID narudžbe',
  'processing.provider': 'Pružatelj usluge',
  'processing.amount': 'Iznos',
  'processing.receiving': 'Primanje',
  'processing.network': 'Mreža',
  'processing.toAddress': 'Na adresu',
  'processing.usuallyMinutes': 'To obično traje nekoliko minuta.',
  'processing.safeToClose': 'Možete sigurno zatvoriti ovu stranicu — poslat ćemo vam e-mail kada bude završeno.',
  'complete.buyTitle': 'Kupnja je završena!',
  'complete.sellTitle': 'Prodaja je završena!',
  'complete.buyDesc': 'Vaši {crypto} su poslani u vaš novčanik.',
  'complete.sellDesc': 'Vaša isplata u {fiat} se obrađuje.',
  'complete.amountBuy': 'Primljeni iznos',
  'complete.amountSell': 'Prodani iznos',
  'complete.paidBuy': 'Plaćeni iznos',
  'complete.paidSell': 'Iznos isplate',
  'complete.network': 'Mreža',
  'complete.wallet': 'Novčanik',
  'complete.transaction': 'Transakcija',
  'complete.provider': 'Pružatelj usluge',
  'complete.orderId': 'ID narudžbe',
  'complete.completed': 'Završeno',
  'complete.viewExplorer': 'Pogledaj na Exploreru',
  'complete.done': 'Gotovo',
  'errorStep.failed': 'Plaćanje nije uspjelo',
  'errorStep.cancelled': 'Narudžba je otkazana',
  'errorStep.expired': 'Narudžba je istekla',
  'errorStep.refunded': 'Narudžba je povraćena',
  'errorStep.unknown': 'Nešto je pošlo po krivu',
  'errorStep.failedBuy': 'Vaše plaćanje nije moglo biti obrađeno. Molimo pokušajte ponovo ili koristite drugi način plaćanja.',
  'errorStep.failedSell': 'Vaša prodaja nije mogla biti obrađena. Molimo pokušajte ponovo.',
  'errorStep.cancelledBuy': 'Vaša narudžba je otkazana. Plaćanje nije izvršeno.',
  'errorStep.cancelledSell': 'Vaša prodaja je otkazana. Nije prenesena nikakva kriptovaluta.',
  'errorStep.expiredBuy': 'Vaša narudžba je istekla. Molimo pokrenite novu kupnju.',
  'errorStep.expiredSell': 'Vaša narudžba je istekla. Molimo pokrenite novu prodaju.',
  'errorStep.refundedBuy': 'Vaše plaćanje je povraćeno. Sredstva bi se trebala pojaviti na vašem računu unutar 5-10 radnih dana.',
  'errorStep.refundedSell': 'Vaša kriptovaluta je vraćena. Sredstva bi se uskoro trebala pojaviti u vašem novčaniku.',
  'errorStep.genericDesc': 'Došlo je do neočekivane greške. Molimo pokušajte ponovo.',
  'errorStep.orderId': 'ID narudžbe',
  'errorStep.tryAgain': 'Pokušaj ponovo',
  'errorStep.startOver': 'Počni ispočetka',
  'errorStep.return': 'Natrag',
  'errorStep.needHelp': 'Trebate pomoć? Kontaktirajte ',
  'errorStep.reference': 'Referenca: {orderId}',
  'confirm.buyTitle': 'Potvrdi kupnju',
  'confirm.sellTitle': 'Potvrdi prodaju',
  'confirm.loading': 'Učitavanje...',
  'confirm.provider': 'Pružatelj usluge',
  'confirm.youPay': 'Vi plaćate',
  'confirm.youSell': 'Vi prodajete',
  'confirm.youReceive': 'Vi primate',
  'confirm.wallet': 'Novčanik',
  'confirm.network': 'Mreža',
  'confirm.refundAddress': 'Adresa za povrat',
  'confirm.parityNote': 'Naplaćeni iznos od pružatelja može se razlikovati. Ostatak do {amount} {crypto} bit će odobren na vaš {partner} račun.',
  'confirm.processing': 'Obrada...',
  'confirm.confirmPay': 'Potvrdi i plati',
  'confirm.confirmSell': 'Potvrdi i prodaj',
  'confirm.payout': 'Isplata u {currency}',
  'modal.selectFiat': 'Odaberi fiat valutu',
  'modal.selectCrypto': 'Odaberi kriptovalutu',
  'modal.choosePayment': 'Odaberi način plaćanja',
  'modal.selectCountry': 'Odaberi svoju državu',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Popularno',
  'modal.recommended': 'Preporučeno',
  'modal.noCurrencies': 'Nije pronađena nijedna valuta',
  'modal.noPaymentMethods': 'Nisu pronađeni načini plaćanja',
  'modal.noCountries': 'Nisu pronađene države',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Lokacija',
  'settings.darkMode': 'Tamni način rada',
  'settings.privacy': 'Pravila privatnosti',
  'settings.terms': 'Uvjeti korištenja',
  'settings.language': 'Jezik',

  // ─── Additional ───
  'modal.chooseRamp': 'Odaberi Ramp',
  'modal.bestPrice': 'Najbolja cijena',
  'modal.noQuotes': 'Nema dostupnih ponuda za ovaj zahtjev',
  'modal.noProvidersFound': 'Nisu pronađeni pružatelji usluge',
  'payment.unavailableFor': 'Nema dostupnih načina plaćanja za {currency}',
  'skeleton.poweredBy': 'Pokreće NowRamp',
  'error.createOrderFailed': 'Narudžba nije mogla biti kreirana',
  'errorStep.returnToMerchant': 'Povratak na trgovca',
  'confirm.cryptoOnNetwork': '{crypto} na {network}',
  'payment.name.card': 'Kartica',
  'payment.name.bankTransfer': 'Bankovni transfer',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default hr;
